// Stub implementations for missing icons
import { DollarSign, Code, Users, Building, GitCompare, MessageSquare } from 'lucide-react';

export const OpenSourceIcon = Code;
export const CoinsIcon = DollarSign;
export const VendorDirectoryIcon = Building;
export const CommunityHubIcon = Users;
export const VendorsIcon = Building;
export const CommunityIcon = MessageSquare;
export const CompareIcon = GitCompare;

// OpenmspLogo moved to real implementation (should be imported from main project)

// OpenFrameLogo moved to real implementation in ./openframe-logo.tsx
